var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattlePperH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 45,
    viewBox: "0 0 36 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3089 6.00858C9.36859 15.0558 4.4932 21.4288 4.50436 21.439C4.50986 21.444 7.01315 21.4725 10.0672 21.5022C13.1213 21.5319 15.6282 21.5631 15.6381 21.5715C15.648 21.5799 12.6733 26.0361 9.02761 31.4741C2.13236 41.7593 0.144622 44.7311 0.0385009 44.9134C-0.0155356 45.0062 -0.0138344 45.0159 0.0508592 44.9823C0.115703 44.9487 7.98991 38.3077 27.1021 22.1677C34.6603 15.7849 35.2088 15.3118 35.113 15.2575C35.0144 15.2015 32.7903 15.1662 27.3154 15.1337C24.5567 15.1173 22.2995 15.0983 22.2995 15.0916C22.2995 15.0848 23.6426 13.2848 25.284 11.0915C32.7166 1.15981 33.4893 0.114713 33.4358 0.0656226C33.4154 0.0468864 30.5906 0.0244305 27.1585 0.0157513L20.9182 0L16.3089 6.00858Z",
    fill: "#838383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattlePperH);
export default __webpack_public_path__ + "static/media/battlePperH.ec7b21381e7deee595155e6602fbf882.svg";
export { ForwardRef as ReactComponent };